import React from "react";

// Components
import Calendar from "../../Calendar/Calendar";
import StackStyle from "../../Styled/Stack.style";
import Modal from "../../Modal/Modal";
import { ExtendDealsConfirmButton } from "../../Controls/ExtendDealsConfirmButton";

export default function ExtendDealsModal({ onSubmit }) {
  const [date, setDate] = React.useState(null);
  const [uiDate, setUIDate] = React.useState(null);

  return (
    <Modal title="Extend deals">
      <StackStyle>
        <Calendar
          value={uiDate}
          setValue={(e) => {
            const temp = new Date(e.target.value);
            const day = temp.getDate();
            const month = temp.getMonth();
            const year = temp.getFullYear();

            // const timeHours = new Date().getHours();
            // const timeMinutes = new Date().getMinutes();
            // const timeSecond = new Date().getSeconds();
            // const time = `${timeHours}:${timeMinutes}:${timeSecond}`
            // dd/mm/yyyy
            const newDate = `${year}-${month + 1}-${day}`;
            setDate(newDate);
            setUIDate(e.target.value);
          }}
        />
        <br />
        <ExtendDealsConfirmButton onClick={() => onSubmit(date)} />
      </StackStyle>
    </Modal>
  );
}
